<div *ngIf="itemCount > 0" class="row gx-1 mb-1 pb-1" [ngClass]="centered ? 'justify-content-center' : ''">
	<div *ngIf=" displayOptions && allFieldsToShow && allFieldsToShow.length> 0" class="col-auto">
		<button type="button" class="btn btn-sm btn-outline-info dropdown-toggle" [id]="'fieldsToShowButton' + ranCode" [disabled]="loading"
			data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
			<fa-icon [icon]="['fas', 'table-columns']"></fa-icon>
			Columns
			{{ ac.bullet }}
			{{ displayOptions.fieldsToShow ? displayOptions.fieldsToShow.length : allFieldsToShow.length }}/{{ allFieldsToShow.length }}
		</button>
		<div class="dropdown-menu cp-scrollable-menu-400 py-2 px-3" [attr.aria-labelledby]="'fieldsToShowButton' + ranCode">
			<table>
				<tr class="cp-row-no-padding"
					[ngClass]="allFieldsToShow.length === displayOptions.fieldsToShow.length ? 'disabled' : 'text-info cp-pointer'"
					(click)="setFieldsToShow(allFieldsToShow)">
					<td colspan="3">
						<fa-icon [icon]="['fas', 'table-columns']"></fa-icon>
						Show All Columns
					</td>
				</tr>
				<tr *ngIf="baselineFields && baselineFields.length > 0 && baselineFields.join(',') !== allFieldsToShow.join(',')"
					class="cp-row-no-padding"
					[ngClass]="baselineFields.join(',') === displayOptions.fieldsToShow.join(',') ? 'disabled' : 'text-info cp-pointer'"
					(click)="setFieldsToShow(baselineFields)">
					<td colspan="3">
						<fa-icon [icon]="['fas', 'table-columns']"></fa-icon>
						Show Default Columns
					</td>
				</tr>
				<tr *ngIf="minimalFields && minimalFields.length > 0" class="cp-row-no-padding"
					[ngClass]="minimalFields.join(',') === displayOptions.fieldsToShow.join(',') ? 'disabled' : 'text-info cp-pointer'"
					(click)="setFieldsToShow(minimalFields)">
					<td colspan="3">
						<fa-icon [icon]="['fas', 'table-columns']"></fa-icon>
						Show Minimal Columns
					</td>
				</tr>
				<tr *ngFor="let cd of columnDefs; let i = index" class="cp-row-no-padding"
					[ngClass]="!lockedFields.includes(cd.field)?'text-info cp-pointer':''" [hidden]="!allFieldsToShow.includes(cd.field)"
					(click)="!lockedFields.includes(cd.field) ? toggleFieldToShow(cd.field) : null">
					<td class="text-center">
						<fa-icon *ngIf="!lockedFields.includes(cd.field) && displayOptions.fieldsToShow.includes(cd.field)"
							[icon]="['fas', 'check-square']"></fa-icon>
						<fa-icon *ngIf="!lockedFields.includes(cd.field) && !displayOptions.fieldsToShow.includes(cd.field)"
							[icon]="['fas', 'square']"></fa-icon>
						<fa-icon *ngIf="lockedFields.includes(cd.field)" [icon]="['fas', 'lock']"></fa-icon>
					</td>
					<td>
						<div [ngbTooltip]="cd.toolTip ? cd.toolTip : cd.label" class="ps-1 pe-2 text-truncate" style="max-width: 250px">
							{{ cd.toolTip ? cd.toolTip : cd.label }}
						</div>
					</td>
					<td class="text-center">
						<fa-icon *ngIf="cd.icon" [icon]="cd.icon" [fixedWidth]="true"></fa-icon>
					</td>
				</tr>
			</table>
		</div>
	</div>

	<div class="col-auto">
		<button type="button" class="btn btn-sm btn-outline-info me-1 dropdown-toggle" id="perPageButton" [disabled]="loading"
			data-bs-toggle="dropdown" aria-expanded="false">
			{{ tt.formatNumber(displayOptions.perPage) }} Per Page
		</button>
		<ul class="dropdown-menu cp-scrollable-menu" aria-labelledby="perPageButton">
			<li *ngFor="let p of ac.perPageSelections; let i = index" class="dropdown-item small text-info cp-pointer"
				(click)="setPerPage(p)" [ngClass]="{ 'border-top': i > 0, 'bg-info text-black': displayOptions.perPage === p }">
				{{ p === -1 ? 'Show Everything' : tt.formatNumber(p) + ' Per Page' }}
			</li>
		</ul>
	</div>

	<div *ngIf="pagingOptions.pages.length > 0" class="col-auto">
		<nav>
			<ul class="pagination mb-0">
				<li class="page-item" [ngClass]="{ 'disabled': displayOptions.pageNum <= 1 }">
					<a class="page-link px-2" href="javascript:void(0)" (click)="setPageNum(displayOptions.pageNum - 1)"
						aria-label="Previous">
						<fa-icon [icon]="['fas', 'angle-left']"></fa-icon>
					</a>
				</li>
				<li *ngFor="let p of pagingOptions.pages" class="page-item">
					<span *ngIf="p === -1" class="page-link px-2">
						<fa-icon [icon]="['fas', 'ellipsis-h']"></fa-icon>
					</span>
					<a *ngIf="p !== -1" class="page-link px-2" href="javascript:void(0)" (click)="setPageNum(p)"
						[ngClass]="{'cp-current-page': +p === +displayOptions.pageNum, 'disabled': pagingOptions.numPages <= 1}">
						{{ p }}
					</a>
				</li>
				<li class="page-item" [ngClass]="{ 'disabled': displayOptions.pageNum >= pagingOptions.numPages }">
					<a class="page-link px-2" href="javascript:void(0)" (click)="setPageNum(displayOptions.pageNum + 1)" aria-label="Next">
						<fa-icon [icon]="['fas', 'angle-right']"></fa-icon>
					</a>
				</li>
			</ul>
		</nav>
	</div>

	<div *ngIf="itemCount > 0" class="col-auto">
		<div [ngClass]="{'border border-info': displayOptions.textFilter && displayOptions.textFilter !== ''}" style="min-width: 200px">
			<div class="input-group">
				<input type="search" [id]="'textFilter' + ranCode" class="form-control form-control-sm" (keyup)="textFilterChangeHandler()"
					(search)="updateTextFilter()" placeholder="Search" [value]="displayOptions.textFilter"
					[ngClass]="{'bg-info': displayOptions.textFilter && displayOptions.textFilter !== ''}" />
				<button type="button" class="btn btn-close bg-transparent" style="padding-top: 14px; margin-left: -25px; z-index: 100;"
					(click)="resetFilters()" ngbTooltip="Clear Search"
					[hidden]="!displayOptions.textFilter || displayOptions.textFilter === ''">
					<!-- <fa-icon [icon]="['fas', 'trash-alt']" class="text-dark"></fa-icon> -->
				</button>
			</div>
		</div>
	</div>
	<div *ngIf="itemCount > 0" class="col-auto ps-1">
		<div [ngClass]="items.length === filteredCount ? 'cp-90 pt-1' : 'cp-75 lh-1'" [innerHTML]="pagingOptions.pagingInfo"></div>
	</div>
</div>

<div *ngIf="itemCount > 0 && filteredCount === 0" class="text-center my-3">
	<span class="border p-2 m-2">
		No Matches to Filter(s) -
		<a href="javascript:void(0)" (click)="resetFilters()">
			Clear/Reset Filters
		</a>
	</span>
</div>